
import PlaceCategoryMixins2 from "@/mixins/filter-genre.mixin";

export default PlaceCategoryMixins2.extend({
  mixins: [PlaceCategoryMixins2],
  name: "component-place-category-genre-category-btn",
  props: {
    dataName: String,
    displayText: String,
  },
  computed: {
    systemLocaleEn(): boolean {
      return this.$i18n.locale.includes("en");
    },
    hasBreakLine(): boolean {
      return this.dataName === "accessible";
      // TODO: 未来に変更し戻す
      // return this.displayText.includes("\\r\\n")
    },
    convertDisplayText(): string {
      return this.displayText === "バリアフリートイレ"
        ? "バリアフリー\r\nトイレ"
        : this.displayText === "Accessible Restroom"
        ? "Accessible\r\nRestroom"
        : this.displayText;
      // TODO: 未来に変更し戻す
      // return this.displayText.includes("\\r\\n") ? this.displayText.replace("\\r\\n","\r\n") : this.displayText
    },
  },
  methods: {
    rowClicked(dataName: string) {
      this.$emit("genre-category-btn-clicked", dataName);
    },
  },
});
